import { render } from "./BlogSideBarZircVeneers.vue?vue&type=template&id=7d396045"
import script from "./BlogSideBarZircVeneers.vue?vue&type=script&lang=js"
export * from "./BlogSideBarZircVeneers.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__